import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import { saveShippingAddress } from "../Redux/Actions/cartActions";
import { useLocation } from "react-router-dom";
import { SHIPPING_RATES } from "../components/ShippingCost"; // Import country list from ShippingCost

const ShippingScreen = ({ history }) => {
  window.scrollTo(0, 0);

  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  const [address, setAddress] = useState(shippingAddress.address || "");
  const [city, setCity] = useState(shippingAddress.city || "");
  const [postalCode, setPostalCode] = useState(shippingAddress.postalCode || "");
  const [setCountry] = useState(shippingAddress.country || "");
  const [countryInput, setCountryInput] = useState(shippingAddress.country || "");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [countrySuggestions, setCountrySuggestions] = useState([]);
  
  // Get countries from shipping rates
  const countryList = Object.keys(SHIPPING_RATES);
  
  // Determine if this is a custom order request
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isCustomOrder = searchParams.get("orderType") === "custom";
  const productId = searchParams.get("productId");
  
  const dispatch = useDispatch();

  useEffect(() => {
    // If we're coming from a direct "Request Similar" flow, we might not have cart items
    // We could potentially add some initialization here if needed
  }, []);

  // Handle country input changes and generate suggestions
  const handleCountryInputChange = (e) => {
    const value = e.target.value;
    setCountryInput(value);
    
    if (value.trim() === "") {
      setShowSuggestions(false);
      setCountrySuggestions([]);
      return;
    }

    // Filter countries based on input
    const filteredCountries = countryList.filter(c => 
      c.toLowerCase().includes(value.toLowerCase())
    );
    
    setCountrySuggestions(filteredCountries);
    setShowSuggestions(true);
  };

  // Handle country selection from suggestions
  const handleSelectCountry = (selectedCountry) => {
    setCountry(selectedCountry);
    setCountryInput(selectedCountry);
    setShowSuggestions(false);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    
    // Save shipping address in Redux store
    dispatch(saveShippingAddress({ address, city, postalCode, country: countryInput }));
    
    // Redirect based on order type
    if (isCustomOrder) {
      // For custom orders (Request Similar flow), include relevant parameters
      history.push(`/placeorder?orderType=custom&productId=${productId}`);
    } else {
      // For regular orders (Add to Cart flow)
      history.push("/placeorder");
    }
  };
  
  return (
    <>
      <Header />
      <div className="page-title-container">
      <div className="container d-flex justify-content-center align-items-center login-center">
        <form
          className="Login col-md-8 col-lg-4 col-11"
          onSubmit={submitHandler}
        >
          <h6>DELIVERY ADDRESS</h6>
          {isCustomOrder && (
            <div className="custom-order-alert">
              <p>You are requesting a custom order similar to the selected product.</p>
            </div>
          )}
          <input
            type="text"
            placeholder="Enter address"
            value={address}
            required
            onChange={(e) => setAddress(e.target.value)}
          />
          <input
            type="text"
            placeholder="Enter city"
            value={city}
            required
            onChange={(e) => setCity(e.target.value)}
          />
          <input
            type="text"
            placeholder="Enter postal code"
            value={postalCode}
            required
            onChange={(e) => setPostalCode(e.target.value)}
          />
          <div className="country-input-container" style={{ position: "relative" }}>
            <input
              type="text"
              placeholder="Enter country"
              value={countryInput}
              required
              onChange={handleCountryInputChange}
              onFocus={() => countryInput && setShowSuggestions(true)}
              onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
            />
            {showSuggestions && countrySuggestions.length > 0 && (
              <div className="country-suggestions" style={{
                position: "absolute",
                width: "100%",
                maxHeight: "200px",
                overflowY: "auto",
                backgroundColor: "white",
                border: "1px solid #ddd",
                borderRadius: "4px",
                zIndex: 1000,
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
              }}>
                {countrySuggestions.map((suggestion, index) => (
                  <div 
                    key={index} 
                    className="suggestion-item"
                    style={{
                      padding: "10px",
                      cursor: "pointer",
                      borderBottom: "1px solid #eee"
                    }}
                    onClick={() => handleSelectCountry(suggestion)}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {suggestion}
                  </div>
                ))}
              </div>
            )}
          </div>
          <button type="submit">
            {isCustomOrder ? "Continue to Custom Details" : "Continue to Order Review"}
          </button>
        </form>
      </div>
      </div>
    </>
  );
};

export default ShippingScreen;